import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { IBusinessTeamMembersResponse } from './types';

export const getBusinessTeamMembers = async (): Promise<IBusinessTeamMembersResponse> => {
    const { data } = await axios.get(pathfinder('business_team_members_api'));

    return data;
};
